import { createContext, useContext } from 'react';

interface TallRowContextValue {
  isTallExpanded: boolean;
  toggleTallExpanded: () => void;
}

export const TallRowContext = createContext<TallRowContextValue | null>(null);

export function useTallRowExpand() {
  return useContext(TallRowContext);
}
